import React from 'react'
import { HEADERS } from '@fareye/utils'
import {
  Card,
  Flex,
  Grid,
  Link,
  styled,
} from '@fareye/ui'
import FileUpload from '../components/FileUpload'

const CustomLink = styled(Link)`
  background: rgb(24, 144, 255);
  color: white;
`

export  function ManualTripClosure() {
  const [meta, setMeta] = React.useState({
    perPage: 20,
    count: 0,
    page: 1
  })

  return (
    <Card>
      <Flex style={{ margin: '10px 10px 50px 10px' }} justifyContentSpaceBetween>
        <Grid gridTemplateColumns="repeat(4,1fr)" gridGap="16px">
          <FileUpload isJourneyAccount={HEADERS().IS_JOURNEY_MODEL}/>
          {HEADERS().IS_JOURNEY_MODEL === 'true' ?
            <CustomLink to="/journey_close.xlsx" target="_blank" download>
            Download Sample File
            </CustomLink> : <CustomLink to="/trip_close.xlsx" target="_blank" download>
            Download Sample File
            </CustomLink>
          }
        </Grid>
      </Flex>
    </Card>
  )
}
